import { render, staticRenderFns } from "./SkeletonMobilesViewsHistoryCard.vue?vue&type=template&id=5c650982&"
import script from "./SkeletonMobilesViewsHistoryCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonMobilesViewsHistoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c650982')) {
      api.createRecord('5c650982', component.options)
    } else {
      api.reload('5c650982', component.options)
    }
    module.hot.accept("./SkeletonMobilesViewsHistoryCard.vue?vue&type=template&id=5c650982&", function () {
      api.rerender('5c650982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/navigationhistory/SkeletonMobilesViewsHistoryCard.vue"
export default component.exports